var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgUpDownArrow = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f2f2f2;}.b{fill:#444a58;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-371 -155)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 14,
    height: 20,
    rx: 3,
    transform: "translate(371 155)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1.592,4.592a.315.315,0,0,1,.447,0L5.6,8.154,9.161,4.592a.316.316,0,0,1,.447.447L5.823,8.823a.315.315,0,0,1-.447,0L1.592,5.038a.315.315,0,0,1,0-.447Z",
    transform: "translate(372.386 162.435)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M.093.093a.315.315,0,0,1,.447,0L4.1,3.655,7.662.093a.316.316,0,0,1,.447.447L4.324,4.324a.315.315,0,0,1-.447,0L.093.539a.315.315,0,0,1,0-.447Z",
    transform: "translate(382.086 163.435) rotate(180)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUpDownArrow);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDE0IDIwIj48ZGVmcz48c3R5bGU+LmF7ZmlsbDojZjJmMmYyO30uYntmaWxsOiM0NDRhNTg7ZmlsbC1ydWxlOmV2ZW5vZGQ7fTwvc3R5bGU+PC9kZWZzPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zNzEgLTE1NSkiPjxyZWN0IGNsYXNzPSJhIiB3aWR0aD0iMTQiIGhlaWdodD0iMjAiIHJ4PSIzIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzNzEgMTU1KSIvPjxwYXRoIGNsYXNzPSJiIiBkPSJNMS41OTIsNC41OTJhLjMxNS4zMTUsMCwwLDEsLjQ0NywwTDUuNiw4LjE1NCw5LjE2MSw0LjU5MmEuMzE2LjMxNiwwLDAsMSwuNDQ3LjQ0N0w1LjgyMyw4LjgyM2EuMzE1LjMxNSwwLDAsMS0uNDQ3LDBMMS41OTIsNS4wMzhhLjMxNS4zMTUsMCwwLDEsMC0uNDQ3WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzcyLjM4NiAxNjIuNDM1KSIvPjxwYXRoIGNsYXNzPSJiIiBkPSJNLjA5My4wOTNhLjMxNS4zMTUsMCwwLDEsLjQ0NywwTDQuMSwzLjY1NSw3LjY2Mi4wOTNhLjMxNi4zMTYsMCwwLDEsLjQ0Ny40NDdMNC4zMjQsNC4zMjRhLjMxNS4zMTUsMCwwLDEtLjQ0NywwTC4wOTMuNTM5YS4zMTUuMzE1LDAsMCwxLDAtLjQ0N1oiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDM4Mi4wODYgMTYzLjQzNSkgcm90YXRlKDE4MCkiLz48L2c+PC9zdmc+";